import { render, staticRenderFns } from "./addPageExpend.vue?vue&type=template&id=4b4a869e&scoped=true&"
import script from "./addPageExpend.vue?vue&type=script&lang=js&"
export * from "./addPageExpend.vue?vue&type=script&lang=js&"
import style0 from "./addPageExpend.vue?vue&type=style&index=0&id=4b4a869e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4a869e",
  null
  
)

export default component.exports